export default {"src":"/_next/static/media/logo-min.95c04594.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};